export class BankModel {
  id: number
  name: string
  bic: string

  constructor(data) {
    this.id = data.id ? data.id : null
    this.name = data.name ? data.name : null
    this.bic = data.bic ? data.bic : null
  }
}



// WEBPACK FOOTER //
// ./src/app/main/models/bank.model.ts